import { render, staticRenderFns } from "./Tab10ParticipantSignatures.vue?vue&type=template&id=21b19ae6&scoped=true"
import script from "./Tab10ParticipantSignatures.vue?vue&type=script&lang=js"
export * from "./Tab10ParticipantSignatures.vue?vue&type=script&lang=js"
import style0 from "./Tab10ParticipantSignatures.vue?vue&type=style&index=0&id=21b19ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b19ae6",
  null
  
)

export default component.exports